'use strict';

export const stageURL = "https://sim2.raraya.co.jp/"
export const prodURL = "https://sim.raraya.co.jp/"

export const ecsystemLinkStage = "https://shop-stage.raraya.co.jp/external/ordermadeparts.php"
export const ecsystemLinkProd = "https://shop.raraya.co.jp/external/ordermadeparts.php"
export const ecsystemApiKeyStage = "ZWJcQYnhM9YNS4OiVcphyDmEtNGr8rKv4qgEUKdDxGZ1WEzBnc"
export const ecsystemApiKeyProd = "oAJA14X5upu0GuC0ZuAlheRyCTPFnACPnrNmXLZBkgRdXHxMEJ"